'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.connect = exports.Provider = undefined;

var _Provider2 = require('./Provider');

var _Provider3 = _interopRequireDefault(_Provider2);

var _connect2 = require('./connect');

var _connect3 = _interopRequireDefault(_connect2);

var _create2 = require('./create');

var _create3 = _interopRequireDefault(_create2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mini-store/lib/index.js
// module id = 71
// module chunks = 0 1